import React, { useRef, useEffect, MutableRefObject } from 'react'
import intlTelInput, { Iti } from 'intl-tel-input'
import { useField } from 'formik'

type Props = {
  name: string;
} & React.ComponentPropsWithoutRef<'input'> & {
  onChange?: (intlTelInput?: Iti) => void;
  afterChange?: (intlTelInput?: Iti) => void;
}

const InputPhoneNumber: React.FC<Props> = ({ name, className = 'form-control', onChange, afterChange, ...rest }) => {
  const [field, , helper] = useField(name)
  const ele = useRef<HTMLInputElement>(null)
  const intlTel = useRef<Iti>()

  useEffect(() => {
    if (ele.current) {
      intlTel.current = intlTelInput(ele.current, {
        containerClass: 'tw-w-full',
        countryOrder: ['SG', 'VN', 'MY'],
        nationalMode: false,
        // @ts-ignore
        loadUtils: () => import('intl-tel-input/utils'),
        formatOnDisplay: false
      })

      ele.current.addEventListener('countrychange', () => {
        afterChange && afterChange(intlTel.current)
      })
    }
  }, [])

  return (
    <input
      ref={ele}
      type="text"
      className={className}
      {...field}
      onInput={() => {
        helper.setValue(intlTel.current?.getNumber())
        helper.setTouched(true)
        afterChange && afterChange(intlTel.current)
      }}
      onBlur={(event) => {
        helper.setValue(intlTel.current?.getNumber())
      }}
      {...rest}
    />
  )
}

export default InputPhoneNumber
